import React from "react";

const Print = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.369"
      height="34.5"
      viewBox="0 0 33.369 34.5"
      stroke="currentColor"
      style={style}
    >
      <g id="Raggruppa_588" transform="translate(-1510.499 -555.5)">
        <g id="Raggruppa_586" transform="translate(1511.499 556.5)">
          <g id="Raggruppa_441" transform="translate(0 0)">
            <path
              id="Tracciato_110"
              d="M0,0H15.031l5.51,4.261V9.07H0Z"
              transform="translate(5.414)"
              fill="none"
              strokeWidth="2"
            />
            <rect
              id="Rettangolo_214"
              width="17.706"
              height="10.581"
              transform="translate(6.719 21.919)"
              fill="none"
              strokeWidth="2"
            />
            <path
              id="Tracciato_109"
              d="M237.553,448.509H213.335a3.575,3.575,0,0,0-3.576,3.576v10.989a3.575,3.575,0,0,0,3.576,3.576h3.143v-5.291h17.706v5.291h3.369a3.576,3.576,0,0,0,3.576-3.576V452.085A3.576,3.576,0,0,0,237.553,448.509Z"
              transform="translate(-209.759 -439.439)"
              fill="none"
              strokeWidth="2"
            />
            <line
              id="Linea_138"
              x2="4.281"
              transform="translate(3.273 14.109)"
              fill="none"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Linea_139"
              x2="1.008"
              transform="translate(12.343 14.109)"
              fill="none"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Linea_140"
              x2="10.329"
              transform="translate(10.327 26.202)"
              fill="none"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Print;
